import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/page-2')({
  component: Page2,
});

const page2Style = { padding: '20px' };

function Page2() {
  return (
    <div style={page2Style}>
      <h1>Page 2</h1>
      <Link to="/">Click here to go back to root page.</Link>
    </div>
  );
}
